import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getPlaces = createAsyncThunk(
  '/getPlaces',
  async () => {
    const response = await axios.get('/GetPlaces');
    return response.data;
  }
);

export const getPlaceDetails = createAsyncThunk(
  '/getPlaceDetails',
  async (id) => {
    const response = await axios.get(`/GetPlaceDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const placeSlice = createSlice({
  name: 'place',
  initialState: {
    selectedItemId: 0,
    loading: false,
    error: '',
    places: [],
    placeDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.placeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
  },
  extraReducers: {
    [getPlaces.pending]: (state) => {
      state.loading = true;
    },
    [getPlaces.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPlaces.fulfilled]: (state, action) => {
      state.places = action.payload;
      state.loading = false;
    },
    [getPlaceDetails.pending]: (state) => {
      state.loading = true;
    },
    [getPlaceDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPlaceDetails.fulfilled]: (state, action) => {
      state.placeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.placeDescriptions = action.payload;
      state.loading = false;
    },
  }
});

export const placeActions = placeSlice.actions;

export default placeSlice;
